import React from 'react';
import BlogContent from './BlogContent';
import CustomTooltip from '../../components/Tooltip/CustomTooltip';
import getTooltip from './BlogTooltips';

const cardStyle = {
  padding: 20
};

const BlogBase = (props) => {
  return (
    <div className="animated fadeIn">
      <div className="card">
        <div className="card-header">
          Hírek
          <CustomTooltip text={getTooltip('hirek')} id="hirekTT" />
        </div>
        <div className="row" style={cardStyle}>
          <div className="col-md-12">
            <BlogContent
              {...props}
              globals={props.globals}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogBase;
